import { useEffect, useRef } from "react";

const EVENTS = ["pointerdown", "pointermove", "keydown", "wheel", "touchstart", "scroll"];

/** Calls onIdle after the visitor hasn't touched, moved, typed or scrolled for `ms` (only counts while the tab is visible). */
export function useIdleTrigger(ms, onIdle, enabled) {
  const last = useRef(Date.now());
  const cb = useRef(onIdle);
  cb.current = onIdle;

  useEffect(() => {
    if (!enabled) return undefined;
    last.current = Date.now();
    const bump = () => {
      last.current = Date.now();
    };
    EVENTS.forEach((e) => window.addEventListener(e, bump, { passive: true, capture: true }));
    const t = setInterval(() => {
      if (document.visibilityState !== "visible") {
        last.current = Date.now();
        return;
      }
      if (Date.now() - last.current >= ms) {
        last.current = Date.now();
        cb.current();
      }
    }, 1000);
    return () => {
      clearInterval(t);
      EVENTS.forEach((e) => window.removeEventListener(e, bump, { capture: true }));
    };
  }, [ms, enabled]);
}
